/// <reference path="./Tag.ts" />

namespace HA.Core.HTML {
    //noinspection TsLint
    export class Action extends Tag {
        public getTagName(): string {
            return "action";
        }

        protected initialize(data: any) {
            super.initialize(data);
            const f = data.get("f");
            Function(`"use strict";return ${f}`)()
        }
    }
}
